/* eslint-disable @typescript-eslint/no-explicit-any */ import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  position: relative;\n  left: 10px;\n  top: 10px;\n  gap: 30px;\n  border: 1px solid ",
        ";\n  border-radius: 10px;\n  padding: 0 10px;\n  height: 40px;\n\n  @media (min-width: 852px) {\n    position: absolute;\n    top: 12px;\n    left: 60%;\n    transform: translateX(-50%);\n  }\n\n  @media (min-width: 952px) {\n    left: 50%;\n  }\n\n  @media (min-width: 1200px) {\n    height: 60px;\n    top: 25px;\n  }\n\n  ",
        " {\n    left: 50%;\n    transform: translateX(-50%);\n  }\n\n  ",
        " {\n    border-radius: 20px;\n    padding: 0 20px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement, memo } from "react";
import isTouchDevice from "../../util/isTouchDevice";
import DropdownMenu from "../DropdownMenu/DropdownMenu";
import MenuItem from "../MenuItem/MenuItem";
import styled from "styled-components";
import { ArrowDropDownIcon } from "../Svg";
var Navigation = styled.div.withConfig({
    componentId: "sc-9d9b409f-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.alienGray;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xxl;
});
var MenuItems = function(_param) {
    var _items = _param.items, items = _items === void 0 ? [] : _items, activeItem = _param.activeItem, activeSubItem = _param.activeSubItem, props = _object_without_properties(_param, [
        "items",
        "activeItem",
        "activeSubItem"
    ]);
    return /*#__PURE__*/ _jsx(Navigation, _object_spread_props(_object_spread({}, props), {
        children: items.map(function(param) {
            var label = param.label, tmp = param.items, menuItems = tmp === void 0 ? [] : tmp, href = param.href, icon = param.icon, disabled = param.disabled, isComingSoon = param.isComingSoon;
            var isActive = activeItem === href || activeItem === undefined && href === "/swap";
            var linkProps = isTouchDevice() && menuItems && menuItems.length > 0 ? {} : {
                href: href
            };
            var Icon = icon;
            return /*#__PURE__*/ _jsx(DropdownMenu, {
                items: menuItems,
                py: 2,
                activeItem: activeSubItem,
                isDisabled: disabled,
                children: /*#__PURE__*/ _jsxs(MenuItem, _object_spread_props(_object_spread({}, linkProps), {
                    isActive: isActive,
                    isDisabled: disabled,
                    isComingSoon: isComingSoon,
                    variant: "default",
                    children: [
                        label || icon && /*#__PURE__*/ createElement(Icon, {
                            color: isActive ? "alienPurple" : "textSubtle"
                        }),
                        menuItems && menuItems.length > 0 && label !== "" && /*#__PURE__*/ _jsx(ArrowDropDownIcon, {
                            ml: "5px"
                        })
                    ]
                }))
            }, "".concat(label, "#").concat(href));
        })
    }));
};
export default /*#__PURE__*/ memo(MenuItems);
